import { Injectable, inject } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Helper } from '@app/core/helper';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private client = inject(HttpClient);


    getTranslation(lang: string, data?: any): Observable<Translation> | Promise<Translation> {
        if (!data) {
            return Promise.resolve({});
        }
        const remoteUrl = Helper.applyCdn('/l10n-4/' + lang + '.json') + '?v=' + environment.assets.v;
        return this.client.get(remoteUrl);
    }
}
